import { Component, input } from '@angular/core';
import { NodeCsrpro } from '@app/models/entity.model';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { MediaComponent } from '../../../components/media/media.component';
import { BreadcrumbComponent } from '../../../components/breadcrumb/breadcrumb.component';
import { TextComponent } from '../../../components/text/text.component';
import { formatNumber } from '@app/helpers/webform';
import { MiscItemComponent } from '../../../components/person/misc-item/misc-item.component';

@Component({
  selector: 'mobi-node-csrpro',
  standalone: true,
  templateUrl: './node-csrpro.component.html',
  styleUrl: './node-csrpro.component.scss',
  imports: [
    EntitySharedModule,
    HeroTextComponent,
    MediaComponent,
    BreadcrumbComponent,
    TextComponent,
    MiscItemComponent,
  ],
})
export class NodeCsrproComponent {
  readonly entity = input.required<NodeCsrpro>();
  formatNumber: (...args: any) => any = formatNumber;
}
